import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import { Navigation } from '@/components/ImageCarousel/components/Navigation';

export const StyledNavigation = styled(Navigation)`
  ${({ type }) => css`
    padding: 0;
    ${type === 'next' ? 'right' : 'left'}: 0;
  `}
  svg {
    height: 32px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  display: grid;
  grid-auto-rows: 1fr;
`;
